import React from "react";
import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";
import { RevealGroup, RevealItem, EASE } from "../ui/Reveal";
import useLang from "../../hooks/useLang";

// Vision and mission, with the logo's blocks stacked beside them.
const VisionMissionSection = () => {
  const { t } = useLang();

  return (
    <section className="bg-paper py-16 sm:py-20 overflow-hidden">
      <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 flex justify-center" aria-hidden="true">
          <div className="relative w-[300px] h-[280px] sm:w-[360px] sm:h-[320px]">
            <motion.div
              className="absolute start-[22%] top-0 w-[58%] h-[46%] rounded-[28px] bg-gradient-to-br from-rose-start to-rose text-white p-5 sm:p-6 flex flex-col justify-between shadow-[0_24px_60px_-24px_rgba(225,29,72,0.55)]"
              initial={{ opacity: 0, y: -40, rotate: 0 }}
              whileInView={{ opacity: 1, y: 0, rotate: 4 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: 0.25, ease: EASE }}
            >
              <span className="font-mono text-[11px] tracking-[0.16em]">{t("visionMission.visionTitle")}</span>
              <Eye size={34} />
            </motion.div>
            <motion.div
              className="absolute start-0 top-[42%] w-[58%] h-[46%] rounded-[28px] bg-ink text-white p-5 sm:p-6 flex flex-col justify-between shadow-[0_24px_60px_-24px_rgba(10,10,10,0.55)]"
              initial={{ opacity: 0, y: 40, rotate: 0 }}
              whileInView={{ opacity: 1, y: 0, rotate: -3 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: EASE }}
            >
              <span className="font-mono text-[11px] tracking-[0.16em] text-rose-light">{t("visionMission.missionTitle")}</span>
              <Target size={34} className="text-rose-light" />
            </motion.div>
            <motion.div
              className="absolute start-[66%] top-[56%] w-[22%] aspect-square rounded-full bg-gradient-to-br from-rose-start to-rose shadow-[0_16px_40px_-10px_rgba(225,29,72,0.6)]"
              initial={{ opacity: 0, scale: 0.4 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.55, ease: EASE }}
            />
          </div>
        </div>

        <RevealGroup className="lg:col-span-7 space-y-10" stagger={0.15}>
          {["vision", "mission"].map((key) => (
            <RevealItem key={key}>
              <h2 className="eyebrow text-rose-dark">{t(`visionMission.${key}Title`)}</h2>
              <p className="mt-4 text-[clamp(1.4rem,2.4vw,2.1rem)] font-bold leading-[1.3] tracking-[-0.02em] text-ink">
                {t(`visionMission.${key}`)}
              </p>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};

export default VisionMissionSection;
